var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrimaryButton',{class:_vm.buttonClass,on:{"click":_vm.buttonClicked}},[_vm._v(" "+_vm._s(_vm.button.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }